import * as S from './index.style'

export type ProgressProps = {
  /** Texto do label abaixo do componente CircularProgress */
  label?: string

  /** Cor do componente CircularProgress */
  colorcircularprogress?: string

  /** Tamanho do componente CircularProgress */
  sizeCircularProgress?: number
}

/** CircularProgress com um label abaixo*/
const Progress: React.FC<ProgressProps> = ({ label, colorcircularprogress = '#54BC82', sizeCircularProgress = 80 }) => (
  <S.Wrapper data-cy="progress">
    <S.Loading size={sizeCircularProgress} color="inherit" colorcircularprogress={colorcircularprogress}></S.Loading>
    <S.Texto>
      <span>Aguarde um momento.</span>
      <br />
      {label}
    </S.Texto>
  </S.Wrapper>
)

export default Progress
